import useLocalizedLocation from "@/hooks/useLocalizedLocation";

import { ContainerProps } from "./types";

function Container({ children, style, justify, align, onClick = undefined, className }: ContainerProps) {
  const { pagePath } = useLocalizedLocation();
  const isChatPage = pagePath?.split("/")[1] === "chat";
  const stylingProperties: object = {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    marginLeft: "auto",
    maxWidth: isChatPage ? undefined : "1580px",
    marginRight: "auto",
    justifyContent: justify,
    alignItems: align,
    flexGrow: 1,
    ...style,
  };
  return (
    <div className={className} style={stylingProperties} onClick={onClick}>
      {children}
    </div>
  );
}
export default Container;
